module.exports = __webpack_public_path__ + "media/klaseaDia1Barco6Vertical.3e2afb11.mp4";